export default __webpack_public_path__ + "static/media/config.e81712fa.png";